export const INSIGHTS_SORTABLE_FIELDS = [
  'priority',
  'plannedStartDateTime',
  'plannedFinishDateTime',
] as const;

export const INSIGHTS_SORT_DIRECTIONS = ['asc', 'desc'] as const;
